import { render, staticRenderFns } from "./SurveyQuestions.vue?vue&type=template&id=b582b3da&"
import script from "./SurveyQuestions.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestions.vue?vue&type=script&lang=js&"
import style0 from "./SurveyQuestions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SurveyOptions: require('/home/runner/work/myody_front/myody_front/components/survey/SurveyOptions.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default})
